import Vue from 'vue'
import { wrapFunctional } from './utils'

const components = {
  NuxtLogo: () => import('../../../../components/NuxtLogo.vue' /* webpackChunkName: "components/nuxt-logo" */).then(c => wrapFunctional(c.default || c)),
  Product: () => import('../../../../components/Product.vue' /* webpackChunkName: "components/product" */).then(c => wrapFunctional(c.default || c)),
  Switcher: () => import('../../../../components/Switcher.vue' /* webpackChunkName: "components/switcher" */).then(c => wrapFunctional(c.default || c)),
  NumberInput: () => import('../../../../components/number-input.vue' /* webpackChunkName: "components/number-input" */).then(c => wrapFunctional(c.default || c)),
  Pill: () => import('../../../../components/pill.vue' /* webpackChunkName: "components/pill" */).then(c => wrapFunctional(c.default || c)),
  ScrollIcon: () => import('../../../../components/scroll-icon.vue' /* webpackChunkName: "components/scroll-icon" */).then(c => wrapFunctional(c.default || c)),
  Tile: () => import('../../../../components/tile.vue' /* webpackChunkName: "components/tile" */).then(c => wrapFunctional(c.default || c))
}

for (const name in components) {
  Vue.component(name, components[name])
  Vue.component('Lazy' + name, components[name])
}
